import { sva } from "@agapi/ui/panda/css";

export const storyItemStyles = sva({
  slots: ['root', 'imageWrapper', 'label'],
  base: {
    root: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: { base: "3", lg: "3" },
      m: "3",
      overflow: 'visible!',
      width: { base: "72px", md: "token(sizes.items.2xl)" },
      '& > a': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      }
    },
    imageWrapper: {
      borderRadius: "full",
      aspectRatio: "1",
      borderColor: "surface.contrast.foreground",
      borderWidth: "5px",
      borderStyle: "solid",
      outlineOffset: "-5px",
      overflow: 'hidden',
      boxShadow: "1px 3px 9px 0px rgba(0, 0, 0, 0.20)",
      width: "auto",
      flexBasis: { base: "72px", md: "token(sizes.items.2xl)" },
      maxWidth: { base: "72px", md: "token(sizes.items.2xl)" },
      flexGrow: "0",
      flexShrink: "0",
    },
    label: {
      textAlign: "center",
      fontSize: "sm",
      lineHeight: "tight",
      p:'0!',
    }
  }
});